/* eslint-disable react/no-array-index-key */
import { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import TextButton from '../elements/TextButton';
import { Text, View } from '../Themed';
import Colors from '../../constants/Colors';

export type SingleChoicePageParamList = {
  prompts: string[];
  options: string[];
  questionCategory: string;
  onSubmit?: (response: any) => void;
};

export default function SingleChoicePage(props: SingleChoicePageParamList) {
  const { prompts, options, questionCategory, onSubmit } = props;
  // const [progress, setProgress] = useState<number>(0);
  const handleSubmit = useCallback(
    (response: any) => {
      if (typeof onSubmit === 'function') {
        onSubmit(response);
      }
    },
    [onSubmit]
  ); // prevents unnecessary renders

  // console.log(`Current options are ${options}`);
  return (
    <View style={styles.container}>
      <View style={styles.promptContainer}>
        {prompts.map((prompt, idx) => {
          return (
            <Text
              style={[styles.prompt, { color: '#14181B' }, { fontWeight: '500' }]}
              key={`SingleChoicePrompt_${idx}`}
            >
              {prompt}
            </Text>
          );
        })}
      </View>
      <View style={styles.optionContainer}>
        {options.map((option, idx) => {
          return (
            <TextButton
              textStyle={{
                fontSize: 20,
                fontWeight: 'bold',
                lineHeight: 25,
                letterSpacing: -0.46,
              }}
              style={styles.option}
              text={option}
              onPress={() => {
                handleSubmit(option);
              }}
              key={`SingleChoiceButton_${idx}`}
            />
          );
        })}
      </View>
    </View>
  );
}
SingleChoicePage.defaultProps = {
  onSubmit: () => {},
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  prompt: {
    textAlign: 'center',

    fontSize: 20,
    lineHeight: 24,
  },
  promptContainer: {
    maxWidth: 300,
    alignSelf: 'center',
  },
  optionContainer: {
    width: 300,
    alignSelf: 'center',
  },
  option: {
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: Colors.snapCalorie.buttonBlue,
    borderRadius: 21,
    width: 300,
    height: 50,
    marginVertical: 24,
    alignSelf: 'center',
  },
});
